.actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.bottomActions {
  display: flex;
  gap: 8px;
}

// The dropdown is opened programmatically (controlled), so the trigger only needs to be a
// positioning reference. Pin it to the ⋯ button's right edge so the calendar's right edge
// lines up with the three-dot menu (both open bottom-end from the same edge).
.anchor {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 0;
  pointer-events: none;
}
